import React from 'react';
import fail from '../Assets/cancel.png';
import { Link, useLocation } from 'react-router-dom';

const Fail = () => {
  const { state } = useLocation();
  const search = state?.search || '';
  const backTo = state?.backTo || `/${search}`;

  return (
    <div className='success-bg'>
      <div className="content-status">
        <img src={fail} className='successimage' alt="Payment failed" />
        <h1 className='payment-text'>Payment Failed</h1>
        <div className='payment-details'>
          <p className='payment-sub'>Something went wrong with your payment.</p>
          <p className='payment-sub'>Please check your details and try again.</p>
        </div>
        <div className='button-container'>
          <Link to={backTo} className='btn-try'>Try Again</Link>
        </div>
      </div>
    </div>
  );
};

export default Fail;
